export const LANGUAGES = ['en'];

export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_LOCALE = 'en';
